var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',{staticClass:"title-page--upper-title"},[_vm._v(_vm._s(_vm.upper_title))]),_c('h1',{staticClass:"title-page--title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }